import React, { useEffect } from "react";
import { useTeams } from "src/scenes/teams/teams-provider";
import { useLocation, useNavigate } from "react-router-dom";
import fetchStatus from "src/utils/api/fetch-status";
import { Box, FormHelperText, Grid, Paper, Stack } from "@mui/material";
import ShowWithSkeleton from "src/utils/show-with-skeleton";
import TeamCard from "src/scenes/teams/team-card";
import { Helmet } from "react-helmet";
import TeamCardEmpty from "src/scenes/teams/team-card-empty";
import styled from "styled-components";
import Link from "@mui/material/Link";

const Title = styled.div`
    margin: 8px;
`;

const Subtitle = styled.p`
    font-size: 12px;
    margin: 8px;
`;
const ResponseText = styled(FormHelperText)`
    color: ${({ theme, error }) => (error ? theme.palette.error.main : theme.palette.primary.main)};
`;

const EnterpriseCreateTeams = () => {
    const [teams, setTeams] = React.useState([]);

    const teamsApi = useTeams();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.state) {
            const timeout = setTimeout(() => {
                navigate("/teams", { replace: true });
            }, 1000);
            return () => clearTimeout(timeout);
        }
        return undefined;
    }, [location && location.state]);

    React.useEffect(() => {
        if (teamsApi.data) {
            const tempTeams = [...teamsApi.data];
            setTeams(tempTeams);
        }
    }, [teamsApi.data]);

    const renderTeams = () => {
        let data;
        if (!teamsApi || teamsApi.status === fetchStatus.PENDING) {
            data = Array(3)
                .fill(0)
                .map((value, id) => ({ id }));
        } else {
            data = teams || [];
        }

        return data.map((team) => (
            <Grid item key={team.id}>
                <ShowWithSkeleton fetchAction={teamsApi}>
                    <TeamCard team={team} />
                </ShowWithSkeleton>
            </Grid>
        ));
    };

    return (
        <>
            <Helmet>
                <title>Adadot - Teams</title>
            </Helmet>
            <Title>Step 3 - Create teams & view data</Title>
            <Grid container direction="row" spacing={2}>
                <Grid item container alignItems="center" spacing={2}>
                    {location.state && (
                        <Stack
                            justifyContent="center"
                            alignItems="center"
                            style={{ width: "100%" }}
                        >
                            <Paper style={{ width: "auto" }}>
                                <Box p={1}>
                                    <ResponseText color="primary">
                                        Team {location.state.data.name} successfully deleted
                                    </ResponseText>
                                </Box>
                            </Paper>
                        </Stack>
                    )}
                    <Grid item container alignItems="center" spacing={3}>
                        <Grid item>
                            <Subtitle>
                                Create{" "}
                                <Link
                                    href="https://docs.adadot.com/Dashboard/Team/"
                                    target="_blank"
                                >
                                    teams
                                </Link>{" "}
                                and add members to see aggregated data for them.
                            </Subtitle>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item container spacing={2}>
                    <Grid item>
                        <TeamCardEmpty />
                    </Grid>
                    {renderTeams()}
                </Grid>
            </Grid>
        </>
    );
};
export default EnterpriseCreateTeams;
